"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.breakpoints = void 0;
/**
| Media-type | [Min | Max] |
| ---------- | ---- | ---- |
| xs         | 0    | 767  |
| sm         | 768  | 1023 |
| md         | 1024 | 1439 |
| lg         | 1440 |      |
 */
var breakpoints = {
    xs: {
        min: '0',
        max: '767px'
    },
    sm: {
        min: '768px',
        max: '1023px'
    },
    md: {
        min: '1024px',
        max: '1439px'
    },
    lg: {
        min: '1440px'
    }
};
exports.breakpoints = breakpoints;
//# sourceMappingURL=breakpoints.js.map